import {
    deleteTransportLoading,
    deleteTransportRequest,
    deleteTransportSuccess,
    deleteTransportReject,
    deleteTransportReset
} from "../../actions/transport/delete";

export const deleteTransport = (formData) => async (dispatch, getState) => {
    dispatch(deleteTransportLoading());
    try {
        const { data } = await deleteTransportRequest(getState, formData);
        dispatch(deleteTransportSuccess(data))
    } catch (error) {
        dispatch(deleteTransportReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteTransportReset()) }, 3000);
    }
    return Promise.resolve();
};